var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll"},[_c('ArrivalCount',{attrs:{"list":_vm.list,"group":_vm.group,"presence":_vm.presence}}),_c('UserArrivalList',{attrs:{"list":_vm.list,"group":_vm.group,"presence":_vm.presence}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }